import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { primaryColor, secondaryColor } from "../../../utils/comon";

const MetricCard = ({
  title,
  value,
  subtitle,
  icon,
  badge,
  footer,
  className = "",
  valueClassName = "",
}) => {
  return (
    <div
      className={`
        bg-cardbg 
        rounded-xl 
        border border-bordercolor 
        shadow-sm 
        hover:shadow-md 
        transition-all 
        duration-200
        p-3  
        ${className}
      `}
    >
      {/* Top Row */}
      <div className="flex items-start justify-between mb-3 sm:mb-4">
        {icon && (
          <div
            className="
              w-6 h-6
              sm:w-6 sm:h-6
              flex items-center justify-center 
              rounded-lg 
              bg-secondaryaccent
              text-primaryaccent
              border border-accentborder
            "
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        )}

        {badge && (
          <div
            className={`text-xs font-bold px-2 py-1 rounded-md ${badge.type === "success"
              ? "bg-green-100 text-green-600"
              : badge.type === "danger"
                ? "bg-red-100 text-red-600"
                : badge.type === "warning"
                  ? "bg-yellow-100 text-yellow-600"
                  : "bg-gray-100 text-gray-600"
              }`}
          >
            {badge.label}
          </div>
        )}
      </div>

      {title && (
        <p className="text-[10px] sm:text-[11px] text-textsecondary font-semibold uppercase tracking-wider">
          {title}
        </p>
      )}

      {value !== undefined && value !== null && value !== "" && (
        <h2
          className={`
            text-xs sm:text-sm lg:text-base 
            font-bold text-textprimary mt-1
            ${valueClassName}
          `}
        >
          {value}
        </h2>
      )}

      {subtitle && (
        <p className="text-xs text-gray-400 mt-1 flex items-center gap-2">
          <span className="material-symbols-outlined  text-[18px]">
            info
          </span>
          {subtitle}
        </p>
      )}

      {footer && (
        <div className="mt-1 pt-3 text-sm text-gray-500 flex items-center gap-2">
          <span className="material-symbols-outlined  text-[18px]">
            info
          </span>
          {footer}
        </div>
      )}
    </div>
  );
};

export default MetricCard;